import { Helmet } from "react-helmet";
import { CheckoutComponentChatAttibutesType } from "../../types/builder";

const JivoChat: React.FC<
  Pick<CheckoutComponentChatAttibutesType, "accountId">
> = ({ accountId }) => {
  return (
    <Helmet>
      <script src={`//code.jivosite.com/widget/${accountId}`} async></script>
    </Helmet>
  );
};

export default JivoChat;
